import React from "react";
import { XCircleIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { caseFactors, struggles } from "../../data/content";
export function Problem() {
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-282" data-mp="2ro54byr0ofeu">
      <div className="mx-auto max-w-3xl" data-id="element-283" data-mp="2rmkegmfndknb">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-plum-950 sm:text-4xl" data-id="element-284" data-mp="2mpk8scmpmjwq">
          Every Pediatric Feeding Case Has Multiple Moving Parts.{" "}
          <span className="text-plum-600" data-id="element-285" data-mp="2cr4ha8jrt8mp">Your Workflow Shouldn’t Add More Confusion.</span>
        </h2>

        <div className="mt-8 space-y-4 text-lg leading-relaxed text-slate-700" data-id="element-286" data-mp="28p9cuv6jmf4p">
          <p className="font-bold text-plum-950" data-id="element-287" data-mp="28rdq43qc0qhn">A child arrives with feeding concerns.</p>
          <p data-id="element-288" data-mp="23siwe6qtthir">
            The caregiver describes a limited food repertoire, stressful mealtimes, or difficulty progressing with certain
            textures. You begin gathering information. But the case quickly becomes more complicated.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-289" data-mp="14aahs3bb4cdm">
          {caseFactors.map(f => <span key={f} className="rounded-full bg-plum-100 px-3.5 py-1.5 text-sm font-bold text-plum-800" data-id="element-290" data-mp="19bq03nm3o4sb">
              {f}
            </span>)}
        </div>

        <p className="mt-6 text-lg leading-relaxed text-slate-700" data-id="element-291" data-mp="108oy9z49ozug">
          You need to determine what information is relevant, what requires additional evaluation, and how to organize the
          findings into a meaningful clinical plan.
        </p>

        <p className="mt-6 rounded-2xl bg-plum-900 p-5 text-center font-display text-xl font-extrabold leading-snug text-white" data-id="element-292" data-mp="1s2h5ke2yvb1f">
          The challenge isn’t simply collecting information. It’s turning that information into a{" "}
          <span className="text-mint-400" data-id="element-293" data-mp="26xdpvpo1vouv">structured professional workflow.</span>
        </p>

        <h3 className="mt-10 font-display text-xl font-extrabold text-plum-950" data-id="element-294" data-mp="2bp5gu1b4bwlj">
          Without a consistent system, you may find yourself:
        </h3>
        <ul className="mt-4 divide-y divide-red-100 rounded-2xl bg-red-50 px-4" data-id="element-295" data-mp="2lijeyhjbul7e">
          {struggles.map(s => <li key={s} className="flex items-start gap-3 py-3.5 text-base font-medium text-slate-800" data-id="element-296" data-mp="2bmg2ahqun467">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-297" data-mp="26nd7dq4l2eby" />
              {s}
            </li>)}
        </ul>

        <p className="mt-6 text-lg leading-relaxed text-slate-700" data-id="element-298" data-mp="22nb4xer0xgvm">
          And when your workflow changes from case to case, maintaining consistent documentation becomes harder.
        </p>
        <p className="mt-3 text-center font-display text-2xl font-extrabold text-plum-700" data-id="element-299" data-mp="1swqa82eh0whz">
          What if you had one practical system to organize the process from initial information gathering to follow-up
          planning?
        </p>

        <div className="mt-8" data-id="element-300" data-mp="1ew5ooyh68mks">
          <CtaButton label="Yes, I Want One Organized System" sub="Instant access · Just $27" data-id="element-301" data-mp="1evxcz9wsbnb6" />
        </div>
      </div>
    </section>;
}